import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

const shimmer = keyframes`
  0%{
    background-position: -1000px 0
  }
  100%{
    background-position: 1000px 0
  }
`

const StyledDiv = styled.div(({
  width, height, radius, margin, reverse, theme: { colors }, transparent,
}) => {
  const backgroundGradient = (
    reverse
      ? 'linear-gradient(to right, #eff1f3 4%, white 25%, #eff1f3 36%)'
      : 'linear-gradient(to right, #e2e2e2 4%, #eff1f3 25%, #e2e2e2 36%)'
  )
  const background = transparent ? 'transparent' : backgroundGradient
  const backgroundColor = transparent ? 'transparent' : colors.light_grey
  return {
    animation: `${shimmer} 2s infinite linear`,
    background,
    backgroundColor,
    backgroundSize: '1000px 100%',
    borderRadius: radius,
    height: height ? `${height}` : '100%',
    margin,
    width: width ? `${width}` : '100%',
  }
})

const LoadingSkeleton = ({
  width, height, radius, margin, reverse, transparent,
}) => (
  <StyledDiv
    data-test="LoadingSkeleton"
    width={width}
    height={height}
    radius={radius}
    margin={margin}
    reverse={reverse}
    transparent={transparent}
  />
)

LoadingSkeleton.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  radius: PropTypes.string,
  margin: PropTypes.string,
  reverse: PropTypes.bool,
  transparent: PropTypes.bool,
}

LoadingSkeleton.defaultProps = {
  width: '',
  height: '',
  radius: '0px',
  margin: 'unset',
  reverse: false,
  transparent: false,
}

LoadingSkeleton.displayName = 'LoadingSkeleton'
LoadingSkeleton.whyDidYouRender = true

export default React.memo(LoadingSkeleton)
